import { IAppState } from '../../common/state';
import { IBuilder } from '../../types/newbuildingHeader';

export function getBuilders({ newbuildingInformation }: IAppState): IBuilder[] | null {
  return newbuildingInformation?.builders || null;
}
